export default __webpack_public_path__ + "static/media/before-after.b0740517.png";